export default __webpack_public_path__ + "static/media/Trio-Tenor-You-are-the-reason-Master-1-1.cfd87157.wav";